import {Autocomplete, Box, Chip, TextField} from '@mui/material';
import {SyntheticEvent, useState} from 'react';
import {AssigneeType} from '../../..';

import {useErpUsers} from '../hooks/useErpUsers';
import {useTicketsFiltersContainer} from '../hooks/useTicketsFiltersContainer';
import {Option} from '../types';

const defaultValue: Option = {label: 'All Groups', value: ''};

export function TicketsListFilterErpUser() {
  const {assigneeTypeFilter, departmentFilter, setErpUserIdsFilter} = useTicketsFiltersContainer();
  const isEligible =
    assigneeTypeFilter &&
    [AssigneeType.erpUser, AssigneeType.erpDepartment].includes(assigneeTypeFilter);

  const {profiles} = useErpUsers(departmentFilter, !isEligible);
  const [selectedUsers, setSelectedUsers] = useState<Option[]>([]);

  const profileOptions = profiles?.data?.map(p => ({label: p.displayName, value: p.id})) ?? [];

  if (!isEligible) {
    return null;
  }

  const handleChange = (_: SyntheticEvent<Element, Event>, newValues: Option[]) => {
    setSelectedUsers(newValues);
    setErpUserIdsFilter(
      newValues.map(option => option.value).filter((id): id is string => id !== undefined)
    );
  };

  return (
    <Box ml={2} display="flex" alignItems="flex-end">
      <Autocomplete
        multiple
        disablePortal
        options={profileOptions}
        value={selectedUsers}
        onChange={handleChange}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        disableCloseOnSelect
        limitTags={3}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip label={option.label} size="small" {...getTagProps({index})} />
          ))
        }
        renderOption={(props, option, {selected}) => (
          <li {...props}>
            <Box component="span" sx={{display: 'flex', alignItems: 'center'}}>
              <input type="checkbox" checked={selected} style={{marginRight: 8}} readOnly />
              {option.label}
            </Box>
          </li>
        )}
        renderInput={params => (
          <TextField
            {...params}
            sx={{
              minWidth: 250,
              '& .MuiInput-root': {
                fontStyle: selectedUsers.length > 0 ? 'inherit' : 'italic',
                color: selectedUsers.length > 0 ? 'inherit' : 'gray',
              },
              '& .MuiInput-root:hover:before': {border: 'none'},
              '& .MuiInput-root:before': {border: 'none'},
              '& .Mui-disabled:before': {border: 'none', borderBottomStyle: 'none !important'},
            }}
            label="ERP Users"
            variant="standard"
          />
        )}
      />
    </Box>
  );
}
